
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { TextareaModule } from 'primeng/textarea';
import { FormsModule } from '@angular/forms';
import { MeetingAiService } from '@/app/plateformebeneficiaire/core/service/meetingAi.service';
import { DocumentsNeededAnalysis, PromptAnalysis, ScopePromptAnalysis } from '@/app/plateformebeneficiaire/core/models/meetingsAi.model';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import { DocumentService } from '@/app/plateformebeneficiaire/core/service/document.service';
import { DocumentMeetingPreparationAcknowledgeDto } from '@/app/plateformebeneficiaire/core/models/document.model';
import { TranslatePipe } from '@/app/layout/pipes/translate.pipe';
import { News } from '@/app/plateformebeneficiaire/core/models/news.model';
import { NewsCardComponent } from "../../news/news-card/news-card.component";
import { NewsService } from '@/app/plateformebeneficiaire/core/service/news.service';

@Component({
    selector: 'app-prepare-meeting-ai',
    templateUrl: './prepare-meeting-ai.component.html',
    styleUrls: ['./prepare-meeting-ai.component.scss'],
    standalone: true,
    imports: [
    CommonModule,
    StepperModule,
    ButtonModule,
    TextareaModule,
    FormsModule,
    MessageModule,
    TranslatePipe,
    NewsCardComponent
]
})
export class PrepareMeetingAiComponent implements OnInit {
    constructor(private route: ActivatedRoute) { }

    #meetingAiService = inject(MeetingAiService);
    #documentService = inject(DocumentService);
    #newsService = inject(NewsService);

    articles : News[] = [];

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const encodedTypesRDV = params['typeRDV'];
            const encodedIdMeeting = params['idMeeting'];
            const encodedTelBeneficiaire = params['telBeneficiaire'];
            if (encodedTypesRDV) {
                try {
                    this.typeRDV = decodeURIComponent(escape(window.atob(encodedTypesRDV)));
                } catch (e) {
                    this.typeRDV = null;
                }
            }

            if (encodedIdMeeting) {
                try {
                    this.idMeeting = decodeURIComponent(escape(window.atob(encodedIdMeeting)));
                } catch (e) {
                    this.idMeeting = null;
                }
            }

            if (encodedTelBeneficiaire) {
                try {
                    this.telBeneficiaire = decodeURIComponent(escape(window.atob(encodedTelBeneficiaire)));
                } catch (e) {
                    this.telBeneficiaire = null;
                }
            }
        });
    }


    typeRDV: string | null = null;
    idMeeting: string | null = null;
    telBeneficiaire: string | null = null;

    step = 1;
    motif = '';
    documents: string[] = [];
    uploads: { [key: string]: File[] } = {};
    resources: { label: string; url: string }[] = [];
    ticketNumber: string = '';
    ticketPin: string = '';
    selected: string[] = [];

    promptAnalysisOutsideScope = signal<boolean>(false);
    promptAnalysisOutsideScopeMessage= signal<string>('');
    promptAnalysisThemes= signal<string[]>([]);
    promptAnalysisLoading = signal<boolean>(false);
    documentsLoading = signal<boolean>(false);
    articlesLoading = signal<boolean>(false);

    toggleSelection(label: string) {
        const index = this.selected.indexOf(label);
        if (index > -1) {
            this.selected.splice(index, 1);
        } else {
            this.selected.push(label);
        }
    }

    previousStep() {
        this.step--;
    }

    async nextStep() {
        if (this.step === 1) this.step++;

        if (this.step === 2 && this.motif) {
            this.promptAnalysisLoading.set(true);
            this.#meetingAiService.evaluatePrompt.mutate({
                prompt: this.motif
            }, {
                onSuccess: (datas: PromptAnalysis) => {
                    if (datas.scope == ScopePromptAnalysis.Externe) {
                        this.promptAnalysisOutsideScope.set(true);
                        this.promptAnalysisOutsideScopeMessage.set(datas.message);
                        this.promptAnalysisLoading.set(false);
                        this.step++;
                    } else if (datas.scope == ScopePromptAnalysis.Interne) {
                        this.promptAnalysisOutsideScopeMessage.set(datas.message);
                        this.promptAnalysisOutsideScope.set(false);
                        this.promptAnalysisThemes.set(datas.themes);
                        this.promptAnalysisLoading.set(false);
                        this.step++;
                    }
                },
                onError: () => { this.promptAnalysisLoading.set(false); }
            });
        }

        if (this.step === 3) {
            this.documentsLoading.set(true);
            this.#meetingAiService.searchDocumentsNeeded.mutate({
                prompt: this.motif,
                themes: this.selected
            }, {
                onSuccess: (datas: DocumentsNeededAnalysis) => {
                    this.documents = datas.documents;
                    this.documents.forEach(doc => this.uploads[doc] = []);
                    this.documentsLoading.set(false);
                    this.step++;
                },
                onError: () => { this.documentsLoading.set(false); }
            });
        }

        if (this.step === 4) {

            this.articlesLoading.set(true);
            this.#meetingAiService.searchNews.mutate({
                prompt: this.motif
            }, {
                onSuccess: (datas: any) => {
                    var articlesId = datas.articles.map((article: any) => article.id);
                    this.#newsService.getNewsByIds.mutate(articlesId, {
                        onSuccess: (news: News[]) => {
                            this.articles = news;
                            this.articlesLoading.set(false);
                            this.step++;
                        },
                        onError: () => { this.articlesLoading.set(false); }
                    });
                    // this.documents = datas.documents;
                    // this.documents.forEach(doc => this.uploads[doc] = []);
                    // this.documentsLoading.set(false);
                },
                onError: () => { this.articlesLoading.set(false); }
            });

        }

        if (this.step === 5)
        {
            console.log(this.idMeeting)
            await this.#documentService.uploadDocumentsPrepareMeeting.mutate({
                idMeeting: this.idMeeting!,
                fichiers: this.flattenUploads(),
                themes: this.selected,
                telBeneficiaire: this.telBeneficiaire!
            }, {
                onSuccess: (datas: DocumentMeetingPreparationAcknowledgeDto) => {
                    this.ticketNumber = datas.ticketNumber
                    this.ticketPin = datas.ticketPin;
                    this.step++;
                },
                onError: () => {

                }
            })
        }
    }

    flattenUploads(): File[] {
        const result: File[] = [];
        for (const key in this.uploads) {
            if (this.uploads.hasOwnProperty(key)) {
                this.uploads[key].forEach((file, index) => {
                    if (file) {
                        const ext = file.name.substring(file.name.lastIndexOf('.'));
                        const newName = `${key}_${index}${ext}`;
                        // Create a new File object with the new name
                        const renamedFile = new File([file], newName, { type: file.type });
                        result.push(renamedFile);
                    }
                });
            }
        }
        return result;
    }

    onFileSelected(event: any, doc: string, index: number) {
        const file = event.target.files[0];
        if (!file) return;
        if (!this.uploads[doc]) this.uploads[doc] = [];
        this.uploads[doc][index] = file;
    }

    addFileField(doc: string) {
        if (!this.uploads[doc]) this.uploads[doc] = [];
        this.uploads[doc].push(undefined as any);
    }

    removeFileField(doc: string, index: number) {
        if (this.uploads[doc]) {
            this.uploads[doc].splice(index, 1);
        }
    }

    allFilesUploaded(): boolean {
        return this.documents.every(doc =>
            this.uploads[doc] && this.uploads[doc].length > 0 && this.uploads[doc].every(f => !!f)
        );
    }
}
